const initialState = {
  totalUnread: 0,
}

const messagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_TOTAL_UNREAD':
      console.log('SET_TOTAL_UNREAD:', action.payload)
      return {
        ...state,
        totalUnread: parseInt(action.payload, 10) || 0,
      }
    case 'INCREMENT_TOTAL_UNREAD':
      console.log('INCREMENT_TOTAL_UNREAD, ancien total:', state.totalUnread)
      return {
        ...state,
        totalUnread: state.totalUnread + 1,
      }
    case 'DECREMENT_TOTAL_UNREAD':
      console.log('DECREMENT_TOTAL_UNREAD, ancien total:', state.totalUnread)
      return {
        ...state,
        totalUnread: Math.max(0, state.totalUnread - 1),
      }
    default:
      return state
  }
}

export default messagesReducer
